export default "__VITE_ASSET__DgTM$QYy__"